import VueRouter from 'vue-router'
import store from './store/store'
import bus from '~/bus.js'
import { useEventWatcher } from '~/helpers/eventHelper'
import useLanguageTree from '~/commons/language'

const InfoTabsData = require('~/marketing.js')
const { t, getAvailableLang } = useLanguageTree()
const AccessView = () => import('./components/views/access/AccessView.vue')
const MyAccountView = () => import('./components/views/account/MyAccountView.vue')
const SimpleApiRequestView = () => import('./components/views/simple-api-requests/SimpleApiRequestView.vue')
const LogoutView = () => import('./components/views/logout/LogoutView.vue')
const ContainersView = () => import('./components/views/containers/ContainersView.vue')
const FileView = () => import('./components/views/file/FileView.vue')
const AccountsView = () => import('./components/views/admin/accounts/AccountsView.vue')
const GroupsView = () => import('./components/views/admin/groups/GroupsView.vue')
const FilesView = () => import('./components/views/files/FilesView.vue')
const FileSearchView = () => import('./components/views/files/FileSearchView.vue')
const FilterFilesView = () => import('./components/views/filter-files/FilterFilesView.vue')
const SharerFilesView = () => import('./components/views/sharer-files/SharerFilesView.vue')
const SharedFilesView = () => import('./components/views/shared/SharedFilesView.vue')
const TransferView = () => import('./components/views/transfer/TransferView.vue')
const MagicLinkView = () => import('./components/views/magic-link/MagicLinkView.vue')
const InfoView = () => import('./components/views/product-info/InfoView.vue')
const NotFoundView = () => import('./components/views/404/404View.vue')

let router = new VueRouter({
  mode: 'history',
  routes: [
    { path: '/', name: 'root', redirect: '/myspace' },
    {
      path: '/access',
      name: 'access',
      component: AccessView,
      meta: {
        title: 'Access'
      }
    },
    {
      path: '/access/login',
      name: 'login',
      component: AccessView,
      meta: {
        title: 'Login'
      }
    },
    {
      path: '/access/register',
      name: 'register',
      component: AccessView,
      meta: {
        title: 'Register'
      }
    },
    {
      path: '/access/forgot-password',
      name: 'forgot-password',
      component: AccessView,
      meta: {
        title: 'ForgotPassword'
      }
    },
    {
      path: '/access/forgot-password/done',
      name: 'forgot-password-done',
      component: AccessView,
      meta: {
        title: 'ForgotPassword'
      }
    },
    {
      path: '/reset-password',
      name: 'reset-password-old'
    },
    {
      path: '/access/reset-password/:token',
      name: 'reset-password',
      component: AccessView,
      meta: {
        title: 'ResetPassword'
      }
    },
    { path: '/transfer/:id/:token', name: 'transfer', component: TransferView },
    {
      path: '/mio',
      name: 'mio',
      component: ContainersView,
      meta: {
        title: 'AvalaibleStudies',
        navElements: {
          root: { name: 'MIO', icon: 'cloud' }
        },
        leftDrawerEnabled: true
      }
    },
    {
      path: '/myspace',
      name: 'myspace',
      component: FilesView,
      meta: {
        title: 'MyIdonia',
        navElements: {
          root: { translate: 'MyIdonia', link: '/myspace', icon: 'dns' }
        },
        tours: ['regular', 'seram2018'],
        rightDrawerEnabled: true,
        leftDrawerEnabled: true
      }
    },
    {
      path: '/myaccount',
      name: 'myaccount',
      component: MyAccountView,
      meta: {
        title: 'My Account',
        navElements: {
          root: { translate: 'My Account', link: '/myaccount', icon: 'person' }
        },
        leftDrawerEnabled: true
      }
    },
    {
      path: '/restore-account',
      name: 'restore-account',
      component: SimpleApiRequestView,
      meta: {
        title: 'Restore Account',
        handler: require('~/components/views/simple-api-requests/request-handlers/AccountRestoration.js')
      }
    },
    {
      path: '/verify-email',
      name: 'verify-email',
      component: SimpleApiRequestView,
      meta: {
        title: 'Verify Email',
        handler: require('~/components/views/simple-api-requests/request-handlers/VerifyEmail.js')
      }
    },
    {
      path: '/shared',
      name: 'shared',
      component: SharedFilesView,
      meta: {
        title: 'SharedWithMe',
        navElements: {
          root: { translate: 'SharedWithMe', link: '/shared', icon: 'group' }
        },
        rightDrawerEnabled: false,
        leftDrawerEnabled: true
      }
    },
    {
      path: '/recents',
      name: 'recents',
      component: FilterFilesView,
      meta: {
        title: 'Recents',
        navElements: {
          root: { translate: 'Recents', link: '/recents', icon: 'access_time' }
        },
        rightDrawerEnabled: true,
        leftDrawerEnabled: true
      }
    },
    {
      path: '/starred',
      name: 'starred',
      component: FilterFilesView,
      meta: {
        title: 'Favorited',
        navElements: {
          root: { translate: 'Favorited', link: '/starred', icon: 'star' }
        },
        rightDrawerEnabled: true,
        leftDrawerEnabled: true
      }
    },
    {
      path: '/trash',
      name: 'trash',
      component: FilterFilesView,
      meta: {
        title: 'Deleted',
        navElements: {
          root: { translate: 'Deleted', link: '/trash', icon: 'delete' }
        },
        rightDrawerEnabled: true,
        leftDrawerEnabled: true
      }
    },
    {
      path: '/sharer/:id/files',
      name: 'sharer-files',
      component: SharerFilesView,
      meta: {
        title: 'MyIdonia',
        navElements: {
          root: { translate: 'SharedWithMe', link: '/shared', icon: 'group' }
        },
        rightDrawerEnabled: true,
        leftDrawerEnabled: true
      }
    },
    { path: '/logout', name: 'logout', component: LogoutView },
    {
      path: '/file/:id',
      name: 'file-view',
      component: FileView,
      meta: {
        navElements: {
          root: { translate: 'MyIdonia', link: '/myspace', icon: 'dns' }
        },
        rightDrawerEnabled: true,
        leftDrawerEnabled: true
      }
    },
    {
      path: '/file/:id/compare/:compare_ids',
      name: 'file-view-compare',
      component: FileView,
      meta: {
        navElements: {
          root: { translate: 'MyIdonia', link: '/myspace', icon: 'dns' }
        },
        rightDrawerEnabled: true,
        leftDrawerEnabled: true
      }
    },
    {
      path: '/file/:id/container/:container',
      name: 'file-container-view',
      component: FileView,
      meta: {
        navElements: {
          root: { translate: 'MyIdonia', link: '/myspace', icon: 'dns' }
        },
        rightDrawerEnabled: true,
        leftDrawerEnabled: true
      }
    },
    {
      path: '/file/:id/container/:container/patient/:patient',
      name: 'file-patients-view',
      component: FileView,
      meta: {
        navElements: {
          root: { translate: 'MyIdonia', link: '/myspace', icon: 'dns' }
        },
        rightDrawerEnabled: true,
        leftDrawerEnabled: true
      }
    },
    {
      path: '/file/:id/container/:container/patient/:patient/study/:study',
      name: 'file-study-view',
      component: FileView,
      meta: {
        navElements: {
          root: { translate: 'MyIdonia', link: '/myspace', icon: 'dns' }
        },
        rightDrawerEnabled: true,
        leftDrawerEnabled: true
      }
    },
    {
      path: '/file/:id/container/:container/patient/:patient/study/:study/series/:series',
      name: 'file-series-view',
      component: FileView,
      meta: {
        navElements: {
          root: { translate: 'MyIdonia', link: '/myspace', icon: 'dns' }
        },
        rightDrawerEnabled: true,
        leftDrawerEnabled: true
      }
    },
    // WADO routes
    {
      path: '/file/:id/wado',
      name: 'file-wado-view',
      component: FileView,
      meta: {
        navElements: {
          root: {translate: 'MyIdonia', link: '/myspace', icon: 'dns'}
        },
        rightDrawerEnabled: true,
        leftDrawerEnabled: true
      }
    },
    {
      path: '/file/:id/wado/study/:study',
      name: 'file-wado-study-view',
      component: FileView,
      meta: {
        navElements: {
          root: { translate: 'MyIdonia', link: '/myspace', icon: 'dns' }
        },
        rightDrawerEnabled: true,
        leftDrawerEnabled: true
      }
    },
    {
      path: '/file/:id/wado/study/:study/series/:series',
      name: 'file-wado-series-view',
      component: FileView,
      meta: {
        navElements: {
          root: { translate: 'MyIdonia', link: '/myspace', icon: 'dns' }
        },
        rightDrawerEnabled: true,
        leftDrawerEnabled: true
      }
    },
    // END WADO routes
    {
      path: '/file/:id/remote',
      name: 'file-remote-view',
      component: FileView,
      meta: {
        navElements: {
          root: {translate: 'MyIdonia', link: '/myspace', icon: 'dns'}
        },
        rightDrawerEnabled: true,
        leftDrawerEnabled: true
      }
    },
    {
      path: '/file/:id/remote/patient/:patient',
      name: 'file-remote-patients-view',
      component: FileView,
      meta: {
        navElements: {
          root: {translate: 'MyIdonia', link: '/myspace', icon: 'dns'}
        },
        rightDrawerEnabled: true,
        leftDrawerEnabled: true
      }
    },
    {
      path: '/file/:id/remote/patient/:patient/study/:study',
      name: 'file-remote-study-view',
      component: FileView,
      meta: {
        navElements: {
          root: {translate: 'MyIdonia', link: '/myspace', icon: 'dns'}
        },
        rightDrawerEnabled: true,
        leftDrawerEnabled: true
      }
    },
    {
      path: '/file/:id/remote/patient/:patient/study/:study/series/:series',
      name: 'file-remote-series-view',
      component: FileView,
      meta: {
        navElements: {
          root: {translate: 'MyIdonia', link: '/myspace', icon: 'dns'}
        },
        rightDrawerEnabled: true,
        leftDrawerEnabled: true
      }
    },
    {
      path: '/mio/:id',
      name: 'mio-file',
      component: FileView,
      meta: {
        navElements: {
          root: { name: 'MIO', link: '/mio', icon: 'cloud' }
        },
        leftDrawerEnabled: true
      }
    },
    { path: '/admin', name: 'admin', redirect: '/admin/accounts' },
    {
      path: '/admin/accounts',
      name: 'admin-accounts',
      component: AccountsView,
      meta: {
        navElements: {
          root: { translate: 'Administration', link: '/admin', icon: 'vpn_key' },
          current: { translate: 'Accounts', link: '/admin/accounts' }
        },
        leftDrawerEnabled: true
      }
    },
    {
      path: '/admin/accounts/new',
      name: 'admin-accounts-new',
      component: AccountsView,
      meta: {
        navElements: {
          root: { translate: 'Administration', link: '/admin', icon: 'vpn_key' },
          path: [{ translate: 'Accounts', link: '/admin/accounts', icon: 'person' }],
          current: { name: 'New Account', link: '/admin/accounts/new' }
        },
        new: true,
        leftDrawerEnabled: true
      }
    },
    {
      path: '/admin/accounts/:id',
      name: 'admin-accounts-edit',
      component: AccountsView,
      meta: {
        navElements: {
          root: { translate: 'Administration', link: '/admin', icon: 'vpn_key' },
          path: [{ translate: 'Accounts', link: '/admin/accounts', icon: 'person' }]
        },
        leftDrawerEnabled: true
      }
    },
    {
      path: '/admin/groups',
      name: 'admin-groups',
      component: GroupsView,
      meta: {
        navElements: {
          root: { translate: 'Administration', link: '/admin', icon: 'vpn_key' },
          current: { translate: 'Groups', link: '/admin/groups', icon: 'people' }
        },
        leftDrawerEnabled: true
      }
    },
    {
      path: '/admin/groups/new',
      name: 'admin-groups-new',
      component: GroupsView,
      meta: {
        navElements: {
          root: { translate: 'Administration', link: '/admin', icon: 'vpn_key' },
          path: [{ translate: 'Groups', link: '/admin/groups', icon: 'people' }],
          current: { name: 'New Group', link: '/admin/groups/new' }
        },
        new: true,
        leftDrawerEnabled: true
      }
    },
    {
      path: '/admin/groups/:id',
      name: 'admin-groups-edit',
      component: GroupsView,
      meta: {
        navElements: {
          root: { translate: 'Administration', link: '/admin', icon: 'vpn_key' },
          path: [{ translate: 'Groups', link: '/admin/groups', icon: 'people' }]
        },
        leftDrawerEnabled: true
      }
    },
    {
      path: '/404',
      name: '404',
      component: NotFoundView,
      meta: {
        title: 'Idonia Magic Link',
        leftDrawerEnabled: true
      }
    },
    {
      path: '/v',
      name: 'magic-link',
      component: MagicLinkView,
      meta: {
        title: 'Idonia Magic Link',
        leftDrawerEnabled: true
      }
    },
    {
      // PIN may also arrive as #PIN or ?secure_id, read by MagicLinkView
      path: '/v/:namespace',
      name: 'magic-link-with-namespace',
      component: MagicLinkView,
      meta: {
        title: 'Idonia Magic Link',
        leftDrawerEnabled: true
      }
    },
    {
      path: '/v/:namespace/:pin',
      name: 'magic-link-with-pin',
      meta: {
        leftDrawerEnabled: true
      },
      component: FileView
    },
    {
      path: '/v/:namespace/:sha/:id',
      name: 'public-file',
      meta: {
        leftDrawerEnabled: true,
        tours: ['guestTour']
      },
      component: FileView
    },
    {
      path: '/v/:namespace/:sha/:id/compare/:compare_ids',
      name: 'public-file-compare',
      meta: {
        leftDrawerEnabled: true,
        tours: ['guestTour']
      },
      component: FileView
    },
    {
      path: '/embed/:id',
      name: 'embed',
      meta: {
        rightDrawerEnabled: false,
        leftDrawerEnabled: false
      },
      component: FileView
    },
    {
      path: '/embed/:id/container/:container',
      name: 'embed-file-container',
      meta: {
        rightDrawerEnabled: false,
        leftDrawerEnabled: false
      },
      component: FileView
    },
    {
      path: '/embed/:id/container/:container/patient/:patient',
      name: 'embed-file-patient',
      meta: {
        rightDrawerEnabled: false,
        leftDrawerEnabled: false
      },
      component: FileView
    },
    {
      path: '/embed/:id/container/:container/patient/:patient/study/:study',
      name: 'embed-file-study',
      meta: {
        rightDrawerEnabled: false,
        leftDrawerEnabled: false
      },
      component: FileView
    },
    {
      path: '/embed/:id/container/:container/patient/:patient/study/:study/series/:series',
      name: 'embed-file-series',
      meta: {
        rightDrawerEnabled: false,
        leftDrawerEnabled: false
      },
      component: FileView
    },
    {

      path: '/info/:lang/:tabId',
      name: 'info-idonia',
      component: InfoView
    },
    {
      path: '/v/:namespace/:sha/:id/container/:container',
      name: 'public-file-container',
      meta: {
        leftDrawerEnabled: true
      },
      component: FileView
    },
    {
      path: '/v/:namespace/:sha/:id/container/:container/patient/:patient',
      name: 'public-file-patient',
      meta: {
        leftDrawerEnabled: true
      },
      component: FileView
    },
    {
      path: '/v/:namespace/:sha/:id/container/:container/patient/:patient/study/:study',
      name: 'public-file-study',
      meta: {
        leftDrawerEnabled: true
      },
      component: FileView
    },
    {
      path: '/v/:namespace/:sha/:id/container/:container/patient/:patient/study/:study/series/:series',
      name: 'public-file-series',
      meta: {
        leftDrawerEnabled: true
      },
      component: FileView
    },
    {
      path: '/v/:namespace/:sha/:id/remote',
      name: 'public-file-remote-container',
      meta: {
        leftDrawerEnabled: true
      },
      component: FileView
    },
    {
      path: '/v/:namespace/:sha/:id/remote/patient/:patient',
      name: 'public-file-remote-patient',
      meta: {
        leftDrawerEnabled: true
      },
      component: FileView
    },
    {
      path: '/v/:namespace/:sha/:id/remote/patient/:patient/study/:study',
      name: 'public-file-remote-study',
      meta: {
        leftDrawerEnabled: true
      },
      component: FileView
    },
    {
      path: '/v/:namespace/:sha/:id/remote/patient/:patient/study/:study/series/:series',
      name: 'public-file-remote-series',
      meta: {
        leftDrawerEnabled: true
      },
      component: FileView
    },
    {
      path: '/print/file/:id',
      name: 'clean-layout'
    },
    {
      path: '/mysearch',
      name: 'mysearch',
      component: FileSearchView,
      meta: {
        title: 'MySearch',
        navElements: {
          root: { translate: 'MySearch', link: '/mysearch', icon: 'search' }
        },
        tours: ['regular', 'seram2018'],
        rightDrawerEnabled: true,
        leftDrawerEnabled: true
      }
    }
  ],
  before: ''
})
const { startEventWatch } = useEventWatcher()
router.beforeEach(async (to, from, next) => {
  if (to.matched.length === 0) {
    next('/404')
    return
  }

  bus.$emit('newRoute', to)
  startEventWatch(to)
  store.dispatch('actionsTray/clearActionsTray')
  store.dispatch('actionsTray/clearActionsFab')
  let isAuthenticated = store.getters['session/isAuthenticated']
  let isAdmin = store.state.session.isAdmin
  router.before = from
  store.dispatch('nav/adminPanel', false)
  store.dispatch('nav/fullView', false)
  let navElements = to.meta.navElements || { root: {}, path: [], current: {} }
  store.dispatch('nav/navElements', navElements)

  if (to.query['force_embed'] === 'true') {
    store.dispatch('viewport/forceEmbed')
    bus.$delete(to.query, 'force_embed')
    next({...to})
    return
  }

  if (to.name !== 'mysearch') {
    if (to.name === 'file-view') {
      store.dispatch('search/clearOffsets')
    } else {
      store.dispatch('search/clearSearch')
    }
  }
  switch (true) {
    case to.name === 'logout':
      next()
      break
    case to.name === 'reset-password-old':
      next('/access/reset-password/' + to.query['t'])
      break
    case to.name === 'info-idonia':
      store.dispatch('nav/fullView', true)
      let data = InfoTabsData[getAvailableLang(to.params.lang, InfoTabsData, (locale) => locale.toLowerCase())]['info']
      let index = data.findIndex(function (item, i) {
        return item.path === to.params.tabId
      })
      store.dispatch('infoTabs/setIndex', index)
      to.params.title = InfoTabsData[getAvailableLang(to.params.lang, InfoTabsData, (locale) => locale.toLowerCase())]['info'][index].title
      to.params.source = InfoTabsData[getAvailableLang(to.params.lang, InfoTabsData, (locale) => locale.toLowerCase())]['info'][index].html
    /* fallthrought */
    case to.name === 'transfer':
    case to.name.startsWith('embed'):
    case to.name === 'magic-link':
    case to.name === 'magic-link-with-pin':
    case to.name === 'restore-account':
    case to.name === '404':
    case to.name === 'myaccount':
    case to.name === 'clean-layout':
      next()
      break
    case to.name === 'magic-link-with-namespace':
      const path = to.path.split('%20')[0]
      if (path === to.path) {
        next()
      } else {
        next(path)
      }
      break
    case typeof to.name === 'string' && to.name.startsWith('public-file'):
      store.dispatch('session/intendedDestination', to.fullPath)
      next()
      break
    case typeof to.name === 'string' && to.name.startsWith('admin'):
      if (isAdmin) {
        store.dispatch('nav/adminPanel', true)
        next()
      } else {
        next('/')
      }
      break
    case to.name === 'access':
      router.push({ path: '/access/login', query: to.query })
      break
    case to.name === 'login':
    case to.name === 'register':
    case to.name === 'forgot-password':
    case to.name === 'forgot-password-done':
    case to.name === 'reset-password':
      if (isAuthenticated) {
        next('/myspace')
      } else {
        next()
      }
      break
    case to.name === 'mysearch':
      if (!store.getters['search/isSearchApplied']) {
        next('/myspace')
      } else {
        next()
      }
      break
    default:
      const intendedDestination = store.state.session.intendedDestination
        ? store.state.session.intendedDestination.split(/[?#]/)[0]
        : ''
      // if (store.state.session.intendedDestination.includes('admin')) {
      if (intendedDestination.includes('http')) {
        next('/access')
      } else if (!isAuthenticated) {
        store.dispatch('session/intendedDestination', to.fullPath)
        next({path: '/access', query: to.query})
      } else {
        if (intendedDestination &&
          intendedDestination !== to.path &&
          !intendedDestination.includes('myspace')) {
          next(store.state.session.intendedDestination)
          store.dispatch('session/intendedDestination', '')
        } else {
          store.dispatch('session/intendedDestination', '')
          next()
        }
      }
  }

  // showing footer policy or terms depending on parameters
  for (var key in to.query) {
    if (key === ('hide_policy_link')) {
      store.dispatch('nav/hidePolicy', (to.query[key] === 'true'))
    }
    if (key === 'hide_terms_link') {
      store.dispatch('nav/hideTerms', (to.query[key] === 'true'))
    }
    if (key === 'hide_footer') {
      store.dispatch('nav/hideFooter', (to.query[key] === 'true'))
    }
  }
})

router.afterEach((to) => {
  if (to.hash === '#getmedicalresults') {
    store.dispatch('dialog/showDialog', {
      body: require('~/components/common/dialog/types/DialogGetMedicalResults.vue').default,
      width: 720,
      persistent: false,
      title: t('Request medical results'),
      props: {
        account: store.state.session.account
      }
    })
    router.replace(to.path)
    // window.history.back()
  }
})

router.afterEach((to, from) => {
  store.dispatch('filters/setParentIDFromPath', to.path)
  if (typeof to.name === 'string' && to.name.startsWith('public-file')) {
    store.dispatch('session/intendedDestination', '')
  } else if (typeof from.name === 'string' && from.name.startsWith('public-file') &&
    to.name !== 'logout') {
    store.dispatch('session/destroyGuestSession')
  }
  if (window.GA_TRACKING_ID && window.GA_TRACKING_ID.length > 0 && typeof window.gtag === 'function') {
    window.gtag('config', window.GA_TRACKING_ID, {
      page_path: to.fullPath,
      send_page_view: true
    })
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router.js